export interface InteractionStatus {
  morning: boolean;
  evening: boolean;
  resilience: boolean;
  night: boolean;
  expectedDateOfLastAnswer: Date;
  hasMissedReflectionsBeforeToday: boolean;
  lastReflectionTip: any;
  newBadges: number;
  requestReview?: boolean;
}

export enum Daytime {
  Morning = 0,
  Midday = 1,
  Evening = 2,
  Resilience = 3,
  Night = 4,
}

export class QuestionTime {
  public daytime: Daytime;
  public date: Date;
}
